<template>
    <SupplyChainChecklist></SupplyChainChecklist>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const SupplyChainChecklist = defineAsyncComponent(() =>
    import("../../components/SupplyChain/CheckList.vue")
);
export default {
    name: "SupplyChain_checklist", //The name you are in should not equal the name of the component you are importing.
    components: { SupplyChainChecklist, AuthLayout },
};
</script>
